import React from 'react'
import FileRow from './FileRowComponent'
import info from '../../assets/Description.svg' // Adjust path as needed
import './index.scss'

const fileRows = [
  {
    extensions: ['.vtt', '.txt', '.ics'],
    description: 'Audio Transcript + Meeting Invite',
    imgSrc: info,
    tooltipTitle:
      'Audio transcript and .ics file combination can be used to generate Workshop Assistant output.',
  },
  {
    extensions: ['.m4a', '.mp4', '.ics'],
    description: 'Meeting Recording + Meeting Invite',
    imgSrc: info,
    tooltipTitle:
      'Meeting recording and .ics file combination can be used to generate Workshop Assistant output.',
  },
  {
    extensions: ['.xls'],
    description: 'RAID Log',
    imgSrc: info,
    tooltipTitle: 'RAID logs can be used to generate Workshop Assitant output.',
  },
  {
    extensions: ['.ppt'],
    description: 'Deep Dive Decks',
    imgSrc: info,
    tooltipTitle: 'Deep Dive Decks can be used to generate Workshop Assitant output.',
  },
  {
    extensions: ['.msg', '.eml'],
    description: 'Emails',
    imgSrc: info,
    tooltipTitle: 'Emails can be used to generate Workshop Assitant output.',
  },
  {
    extensions: ['.png', '.jpeg'],
    description: 'Screenshots/Images',
    imgSrc: info,
    tooltipTitle: 'Screenshots/Images can be used to generate Workshop Assitant output.',
  },
  {
    extensions: ['.docx', '.pdf', '.pptx', '.xlsx'],
    description: 'Related Documentation',
    imgSrc: info,
    tooltipTitle: 'Additional documents can be used to generate Workshop Assitant output.',
  },
]

const OptionalFileList: React.FC = () => (
  <>
    <div className='upload-multiple-file-content-left-heading'>Optional files:</div>
    {fileRows.map((row, index) => (
      <FileRow
        key={index}
        extensions={row.extensions}
        description={row.description}
        imgSrc={row.imgSrc}
        tooltipTitle={row.tooltipTitle}
      />
    ))}
  </>
)

export default OptionalFileList
